import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Route, Switch } from 'react-router-dom';
import './App.css';
import ContactUS from './components/ContactUS';
import Faq from './components/Faq';
import PartSurfer from './components/PartSurfer';
import UserGuide from './components/UserGuide';
import Hierarchy from './components/Hierarchy';
import NewRequest from './components/NewRequest';
import GenerateMetrics from './components/GenerateMetrics';
//import Sbom from './components/Sbom';
import GoToTop from './components/GoToTop';
import CallBack from './components/CallBack';
import cors from "cors";
import ImageUpload from './components/ImageUpload';

class App extends React.Component {
  render() {
   
    return (
      <React.Fragment>
        <Helmet
          title="HP PartSurfer">
            {
            process.env.REACT_APP_HEADER_LINK ? <script
              src={process.env.REACT_APP_HEADER_LINK}
              type="text/javascript"
            /> : undefined
          }

        </Helmet>
        <Switch>
          <Route path="/PartSurfer/Faq" component={Faq}/>
          <Route path="/PartSurfer/UserGuide" component={UserGuide}/>
          <Route exact path="/" component={PartSurfer} />
          <Route  path="/PartSurfer/ContactUS" component={ContactUS}/>
          <Route  path="/PartSurfer/Hierarchy" component={Hierarchy}/>
          <Route  path="/PartSurfer/NewRequest" component={NewRequest}/>
          <Route  path="/PartSurfer/GenerateMetrics" component={GenerateMetrics}/>
           {/* <Route  path="/PartSurfer/Sbom/:value" component={Sbom}/>Commented by Shreyas N to remove this functionality as per client request */}
          <Route exact path="/PartSurfer/CallBack/" component={CallBack} />
          <Route exact path="/PartSurfer/ImageUpload" component={ImageUpload} />
          
        </Switch>

        <GoToTop/>{/* Added by Shreyas N for GO To Top functionality. */}

      </React.Fragment>
    );
  }
}

export default App;
